import { render } from "./FicaUploadsUpdate.vue?vue&type=template&id=6bbd8a2e&scoped=true"
import script from "./FicaUploadsUpdate.vue?vue&type=script&lang=js"
export * from "./FicaUploadsUpdate.vue?vue&type=script&lang=js"

import "./FicaUploadsUpdate.vue?vue&type=style&index=0&id=6bbd8a2e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbd8a2e"]])

export default __exports__